<!DOCTYPE HTML>
<template>
<div class="project-details"
     v-if="project">

  <div class="cols">
    <div class="left">
      <CloseButton @close="close" />

      <div>
        <div class="uppercaseheader">Project</div>
        <h2>{{project.name}}</h2>
      </div>
      <div>
        <div class="uppercaseheader">Created on</div>
        <p>{{asShortDate(project.created)}}</p>
      </div>
      <div>
        <div class="uppercaseheader">Description</div>
        <p>{{project.description}}</p>
      </div>

    </div>

    <b-list-group class="right">

      <b-list-group-item v-if="project.budget">
        <div class="uppercaseheader">Budget</div>
        <div class="budget">
          {{asCurrency(project.budget)}}
        </div>
      </b-list-group-item>

      <b-list-group-item v-if="project.timeline">
        <div class="uppercaseheader">Due date</div>
        <div>
          {{project.timeline}}
        </div>
      </b-list-group-item>

      <b-list-group-item v-if="allSkills(project).length > 0 ">
        <div class="uppercaseheader">Attributes</div>
        <div>
          <Pillgroup :items="allSkills(project)"
                     :truncate="5" />
        </div>
      </b-list-group-item>

      <b-list-group-item>
        <b-button variant="danger"
                  @click="deleteProject">Delete project</b-button>
      </b-list-group-item>

    </b-list-group>
  </div>


</div>
</template>

<script>
// Components
import Pillgroup from '@/components/Pillgroup.vue'
import CloseButton from '@/components/CloseButton.vue'
// Mixins
import { Formatter, Skills, Status } from '@/mixins/Mixins.js'
export default {
  name: 'MyProjectDetails',
  components: {
    Pillgroup,
    CloseButton,
  },
  mixins: [ Formatter, Skills, Status ],
  props: {
    userData: Object,
    project: Object,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    close() {
      this.$emit( 'close' )
    },
    deleteProject() {
      this.project.ref.delete().then( () => {
        this.$emit( 'close' )
      } )
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/global.scss";
.project-details {
    .cols {
        display: grid;
        grid-template-columns: 3fr 2fr;
        grid-column-gap: 4rem;

        .left {
            display: grid;
            grid-row-gap: 1rem;
            align-content:: flex-start;

            p {
                font-family: 'Roboto';
                color: theme-color-level('primary',-5);
            }

        }
        .right {
            .list-group-item {
                display: grid;
                grid-row-gap: 0.5rem;

                .budget {
                    font-size: 1.5rem;
                }
            }
        }
    }
}
</style>
